var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCirclePink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 11.6667C23.3333 18.11 18.11 23.3333 11.6667 23.3333C5.22335 23.3333 0 18.11 0 11.6667C0 5.22335 5.22335 0 11.6667 0C18.11 0 23.3333 5.22335 23.3333 11.6667ZM11.6667 6.125C12.1499 6.125 12.5417 6.51675 12.5417 7V10.7917H16.3333C16.8166 10.7917 17.2083 11.1834 17.2083 11.6667C17.2083 12.1499 16.8166 12.5417 16.3333 12.5417H12.5417V16.3333C12.5417 16.8166 12.1499 17.2083 11.6667 17.2083C11.1834 17.2083 10.7917 16.8166 10.7917 16.3333V12.5417H7C6.51675 12.5417 6.125 12.1499 6.125 11.6667C6.125 11.1834 6.51675 10.7917 7 10.7917H10.7917V7C10.7917 6.51675 11.1834 6.125 11.6667 6.125Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCirclePink);
export default __webpack_public_path__ + "static/media/plus-circle-pink.9b4b558411bdd80a9d0c5c2bdb5e2ec4.svg";
export { ForwardRef as ReactComponent };